module.exports = __webpack_public_path__ + "static/media/jug.e2640fb3.svg";